import React, { useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import { Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';

import ImageUpload from './ImageUpload';
import { authProvider, storage, auth, db } from './firebase';
import './Profile.css';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  tab: {
    flexGrow: 1,
  },
}));

function Profile({ username, email, user, password }) {
  const [image, setImage] = useState(null);
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [docId, setDocId] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [userDetail, setUserDetail] = useState('');
  const [editProfile, setEditProfile] = useState(false);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fileRef = storage.ref(`avatars/${email}-avatar.png`);
    if (fileRef) {
      fileRef.getDownloadURL().then(onResolve);

      function onResolve(foundURL) {
        setImage(foundURL);
      }
    }

    db.collection('userprofile')
      // .doc(postId)
      // .collection('comments')
      // .orderBy('timestamp', 'desc')
      .onSnapshot((snapshot) => {
        // setComments(snapshot.docs.map((doc) => doc.data()));
        snapshot.docs.map((doc) => {
          // setUserDetail(doc.data())
          if (email === doc.data().userEmail) {
            console.log(
              '----email:',
              doc.data().userEmail,
              doc.data().zipCode,
              doc.data(),
              doc.id
            );
            setUserDetail(doc.data());
            setDocId(doc.id);
          }
        });
        // if(doc.data())
      });
    // console.log('pass in effect--', password);
    // console.log('pass in effect--', user);
  }, []);

  const addImage = () => {
    document
      .getElementById('files')
      .addEventListener('change', handleChangeAvatar, false);
    document.getElementById('files').click();
  };
  const handleChangeAvatar = (e) => {
    if (e.target.files.length) {
      const files = e.target.files;
      imageUpload(files);
    }
  };
  const Update = () => {
    if (email === userDetail.userEmail) {
      {
        zipCode &&
          db.collection('userprofile').doc(docId).update({
            zipCode: zipCode,
          });
      }

      {
        address &&
          db.collection('userprofile').doc(docId).update({
            address: address,
          });
      }

      {
        phone &&
          db.collection('userprofile').doc(docId).update({
            phone: phone,
          });
      }
    } else {
      db.collection('userprofile').add({
        // userName: userName,
        userEmail: email,
        zipCode: zipCode,
        address: address,
        phone: phone,
      });
    }

    alert("It's been updated!");
  };
  const imageUpload = (image) => {
    const uploadTask = storage.ref(`avatars/${email}-avatar.png`).put(image[0]);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // const progress = Math.round(
        //   (snapshot.bytesTransfeered / snapshot.totalBytes) * 100
        // );
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref(`avatars/${email}-avatar.png`)
          .getDownloadURL()
          .then((url) => {
            setImage(url);
          });
      }
    );
  };
  const onEdit = () => {
    {
      !editProfile ? setEditProfile(true) : setEditProfile(false);
    }
  };
  return (
    <div className='Profile' style={{ position: 'relative', display: 'block' }}>
      <br></br>
      <div style={{ display: 'flex' }}>
        {/* <div className='profile_avatar' style={{ width: '20%' }}>
          <input type='file' id='files' style={{ display: 'none' }} />
          <Button component='label'>
            <Avatar style={{ width: '200px', height: '200px' }} src={image} />
            <button style={{ display: 'none' }} onClick={addImage}></button>
          </Button>
        </div> */}
        <div
          style={{
            display: 'block',
            width: '48%',
            // justifyContent: '',
            // marginLeft: '26%',
          }}>
          <div>
            {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div className='col-md-6'>
                <h3> Welcome </h3>
              </div>
              <div className='col-md-6'>
                <h3>&nbsp;&nbsp;&nbsp;&nbsp;{username}! </h3>
              </div>
            </div> */}
            <div
              style={{
                display: 'flex',
                // justifyContent: 'center',
                paddingTop: '5%',
              }}>
              <aside style={{ textAlign: 'start', width: '100%' }}>
                <label style={{ color: 'rgb(189, 189, 189)' }}>
                  Contact Information
                </label>
              </aside>
              <button style={{ width: '100px' }} onClick={() => onEdit()}>
                {' '}
                Edit Profile{' '}
              </button>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '5%',
              }}>
              <aside style={{ width: '30%', textAlign: 'start' }}>
                <label style={{ fontWeight: 'bold' }}> Email </label>
              </aside>

              <h4
                style={{
                  width: '70%',
                  textAlign: 'start',
                  color: '#6b7dde',
                  fontSize: '16px',
                }}>
                &nbsp;&nbsp;&nbsp;&nbsp; {email}
              </h4>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '4%',
              }}>
              <aside style={{ width: '30%', textAlign: 'start' }}>
                <label style={{ fontWeight: 'bold' }}> Phone </label>
              </aside>
              <h4
                style={{
                  width: '70%',
                  textAlign: 'start',
                  color: '#6b7dde',
                  fontSize: '16px',
                }}>
                &nbsp;&nbsp;&nbsp;&nbsp; {userDetail.phone}
              </h4>
            </div>
            <div
              style={{
                display: 'flex',
                // justifyContent: 'center',
                paddingTop: '5%',
              }}>
              <aside style={{ textAlign: 'start' }}>
                <label style={{ color: 'rgb(189, 189, 189)' }}>
                  Basic Information
                </label>
              </aside>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '4%',
              }}>
              <aside style={{ width: '30%', textAlign: 'start' }}>
                <label style={{ fontWeight: 'bold' }}> Zip Code </label>
              </aside>
              <h4
                style={{
                  width: '70%',
                  textAlign: 'start',
                  color: '#6b7dde',
                  fontSize: '16px',
                }}>
                &nbsp;&nbsp;&nbsp;&nbsp; {userDetail.zipCode}
              </h4>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '4%',
              }}>
              <aside style={{ width: '30%', textAlign: 'start' }}>
                <label style={{ fontWeight: 'bold' }}> Address </label>
              </aside>
              <h4
                style={{
                  width: '70%',
                  textAlign: 'start',
                  color: '#6b7dde',
                  fontSize: '16px',
                }}>
                &nbsp;&nbsp;&nbsp;&nbsp; {userDetail.address}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <br></br>
      <hr style={{borderBottom:'groove', borderTopStyle:'none'}}></hr>
      {editProfile && (
        <form className={classes.root} noValidate autoComplete='off' style={{}}>
          {/* <div> */}
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '5%',
              margin: '0px',
            }}>
            <label
              style={{
                fontWeight: 'bold',
                margin: '0',
                padding: '0',
                border: '0',
                font: 'inherit',
                verticalAlign: 'baseline',
              }}></label>
            <p style={{ color: 'rgb(189, 189, 189)' }}>Personal Information</p>
          </div>

          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0px',
            }}>
            <aside
              style={{ paddingRight: '5%', width: '25%', textAlign: 'start' }}>
              <label
                style={{
                  width: '50%',
                  fontWeight: 'bold',
                  margin: '0',
                  padding: '0',
                  border: '0',
                  font: 'inherit',
                  verticalAlign: 'baseline',
                }}>
                Zip Code
              </label>
            </aside>
            <input
              value={zipCode}
              placeholder='Zip Code'
              onChange={(e) => {
                setZipCode(e.target.value);
              }}
              className='userform'
              // style={{ width: '35%', background:'0,0', border:'1px solid rgba(var(--ca6,219,219,219),1)', borderRadius:'3px', boxSizing:'' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0px',
            }}>
            <aside
              style={{ paddingRight: '5%', width: '25%', textAlign: 'start' }}>
              <label
                style={{
                  fontWeight: 'bold',
                  margin: '0',
                  padding: '0',
                  border: '0',
                  font: 'inherit',
                  verticalAlign: 'baseline',
                }}>
                Address
              </label>
            </aside>
            <input
              value={address}
              placeholder='Address'
              onChange={(e) => {
                setAddress(e.target.value);
              }}
              className='userform'
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0px',
            }}>
            <aside
              style={{ paddingRight: '5%', width: '25%', textAlign: 'start' }}>
              <label
                style={{
                  width: '50%',
                  fontWeight: 'bold',
                  margin: '0',
                  padding: '0',
                  border: '0',
                  font: 'inherit',
                  verticalAlign: 'baseline',
                }}>
                Phone Number
              </label>
            </aside>
            <input
              value={phone}
              placeholder='Phone Number'
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              className='userform'
            />
          </div>

          <div
            style={{
              width: '100%',
              paddingTop: '5%',
              textAlign: 'start',
              margin: '0px',
            }}>
            <Button
              variant='contained'
              color='primary'
              className={classes.button}
              onClick={() => Update()}>
              Update
            </Button>
          </div>
          {/* </div> */}
        </form>
      )}
    </div>
  );
}

export default Profile;
